import { EVENTS } from 'util.events'
import { HTMLThemeElement } from 'element.theme'

class PsnmStockStatus extends HTMLThemeElement {
  connectedCallback() {
    this.abortController = new AbortController()
    this.productId = this.dataset.productId

    document.addEventListener(
      `${EVENTS.variantChange}:${this.dataset.sectionId}:${this.productId}`,
      this.updateStock,
      { signal: this.abortController.signal }
    )
  }

  disconnectedCallback() {
    this.abortController.abort()
  }

  updateStock = (event) => {
    const { html, variant, loading } = event.detail

    if (loading) return

    if (!variant) {
      this.innerHTML = ''
      return
    }

    if (!html) return

    const fresh = html.querySelector(`psnm-stock-status[data-product-id="${this.productId}"]`)

    if (fresh) {
      this.innerHTML = fresh.innerHTML
    }
  }
}

customElements.define('psnm-stock-status', PsnmStockStatus)
